import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import type { GetServerSideProps, NextPage } from 'next';
import styles from './styles.module.scss';
import Head from 'next/head';
import { PageLayout } from '@/components/pagelay';
import axios from 'axios';
import cName from 'classnames';
import { useRouter } from 'next/router';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Notification } from '@douyinfe/semi-ui';
import { PRODDOMAIN, PRODFORNTDOMAIN } from '@/utils';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const showdown = require('showdown');

interface IProps {

}

export const getServerSideProps: GetServerSideProps = async context => {
  const { newsId } = context.query;
  const { data } = await axios.get(`${PRODDOMAIN}/api/news/${newsId}?lang=cn`);

  return {
    props: data.data, // 需要拿props包裹
  };
};


export default (data: any) => {
  const converter = new showdown.Converter();

  return (
    <div>
      <PageLayout
        crumb={[
          { path: `/media/news/news_detail/${data?.id}`, name: data?.info?.title },
        ]}
        newsPath={data?.category_id === 3 ? '/media/industry' : '/media/news'}
      >
        <div className={styles.container}>
          <Head>
            <title>{data?.info?.meta_title || data?.info?.title}</title>
            {data?.info?.desc && <meta name="description" content={data?.info?.desc} />}
            {data?.info?.meta_kws && <meta name="keywords" content={data?.info?.meta_kws} />}
          </Head>
          <div className={styles.left}>
            <h1>{data?.info?.title}</h1>
            <div className={styles.share}>
              <span>{new Date(String(data?.publish_time).length === 10 ?
                data?.publish_time * 1000 : data?.publish_time
              ).toLocaleString().replace(/\//g, '-').split(' ')[0]}</span>
              <div>
                <CopyToClipboard text={`${PRODFORNTDOMAIN}/media/news/news_detail/${data?.id}`}
                  onCopy={() => {
                    Notification.success({
                      content: '复制成功！快去微信分享文章吧',
                      duration: 3,
                    })
                  }}
                >
                  <div className={styles.wx}></div>
                </CopyToClipboard>
                <div className={styles.xinlang}
                  onClick={() => [
                    window.open(
                      "http://service.weibo.com/share/share.php?url=" +
                      encodeURIComponent(`${PRODFORNTDOMAIN}/media/news/news_detail/${data?.id}`) +
                      "?sharesource=weibo&title=" +
                      data?.info?.title
                    )
                  ]}></div>
              </div>
            </div>
            <div
              dangerouslySetInnerHTML={{ __html: converter.makeHtml(data?.info?.content) }}
              className={styles.content} />
            <div className={styles.footer}>
              <span>上一篇：<a href={data?.prev_article?.info?.outlink
                ? data?.prev_article?.info?.outlink
                : `/media/news/news_detail/${data?.prev_article?.id}`}>{data?.prev_article?.info?.title}</a></span>
              <span>下一篇：<a href={data?.next_article?.info?.outlink
                ? data?.next_article?.info?.outlink
                : `/media/news/news_detail/${data?.next_article?.id}`}>{data?.next_article?.info?.title}</a></span>
            </div>
          </div>
          <div className={styles.right}>
            <h2>更多新闻</h2>
            {
              data?.related_articles?.map((item: any) => (
                <a href={item.info.outlink
                  ? `${item.info.outlink}` :
                  `/media/news/news_detail/${item.id}`}
                  target={item.info.outlink ? "_blank" : ''}
                  key={item.id}>
                  <div className={styles.newItem}>
                    <img src={item.info.image} alt="" />
                    <div>
                      <h3>{item.info.title}</h3>
                      <p>{item.info.brief}</p>
                      <span>{new Date(String(item.publish_time).length === 10 ?
                        item.publish_time * 1000 : item.publish_time
                      ).toLocaleString().replace(/\//g, '-').split(' ')[0]}</span>
                      <img className={styles.btn} src="/image/news-bg-btn.png" alt="" />
                    </div>
                  </div>
                </a>
              ))
            }
          </div>
          <style jsx global>
            {
              `

              `
            }
          </style>
        </div>
      </PageLayout >
    </div >
  );
};